module.exports = {
      id: "profile-usage",
      viewBox: "0 0 80 80",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#profile",
      toString: function () {
        return this.url;
      }
    }